var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultMarketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.273 26.21c3.823 4.042 7.973 5.79 7.973 5.79s4.15-1.748 7.973-5.79a99.42 99.42 0 0 1-8.3.329c-1.202-.11-4.15-.11-7.646-.328zM38.117 22.281c-4.041.655-8.956 1.092-14.09 1.092-12.996 0-21.078-2.293-21.951-3.932l-1.639.765c1.748 3.386 13.434 4.915 23.59 4.915 5.352 0 10.376-.437 14.526-1.093l.219 1.093 7.317-3.495-8.19-.328.218.983z",
    fill: "#0A68FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.225 14.635c.219-1.201.328-2.512.328-3.823C38.553 3.167 36.478 0 36.478 0s-5.789 3.386-12.232.765C17.802 3.385 12.014 0 12.014 0S9.939 3.167 9.939 10.812c0 1.202.109 2.294.218 3.386-.983.11-1.966.328-2.84.437l-.327-1.092L0 17.038l8.191.218-.328-1.092c.874-.219 1.748-.328 2.73-.437.438 1.966 1.202 3.823 2.076 5.46 3.058.438 6.88.656 11.358.656 4.478 0 8.41-.218 11.905-.765a20.016 20.016 0 0 0 1.856-4.914c4.587.874 6.88 2.075 6.88 2.949 0 .109 0 .218-.108.218l1.638.983c.218-.328.328-.764.328-1.092 0-2.184-3.605-3.713-8.3-4.587z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMarketIcon);
export default ForwardRef;